import { render, staticRenderFns } from "./MobileLanding.vue?vue&type=template&id=67c083ee&"
import script from "./MobileLanding.vue?vue&type=script&lang=js&"
export * from "./MobileLanding.vue?vue&type=script&lang=js&"
import style0 from "./MobileLanding.vue?vue&type=style&index=0&id=67c083ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports